import React, {Component} from 'react'
import {Nav, NavLink, NavItem, TabContent, TabPane, Row, Col} from 'reactstrap'
import {Query} from 'react-apollo'
import classnames from 'classnames'
import {ToastContainer} from 'react-toastify'

import clientQuery from '../../../queries/server/user_role'
import Loading from "../Loading";
import UserRoleForm from "../user_roles/UserRoleForm";
import UserRoleRates from "./UserRoleRates";


class UserRole extends Component {

    state = {
        activeTab: 'details'
    }

    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    render() {

        const {user_role_id} = this.props.match.params

        return (
            <Query query={clientQuery} variables={{user_role_id}}>
                {({data, loading, error}) => {

                    console.log('user_role', data)

                    if (loading) return <Loading/>

                    return (
                        <div className="m-4">

                            <h1 className="mb-4">{data.user_role.description}</h1>

                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'details'})}
                                        onClick={() => {
                                            this.toggle('details');
                                        }}
                                    >
                                        Details
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'hourly_rates'})}
                                        onClick={() => {
                                            this.toggle('hourly_rates');
                                        }}
                                    >
                                        Hourly Rates
                                    </NavLink>
                                </NavItem>

                            </Nav>
                            <TabContent activeTab={this.state.activeTab}>
                                <TabPane tabId="details">
                                    <Row>
                                        <Col sm="12 mt-4">
                                            <UserRoleForm
                                                {...data.user_role}
                                            />
                                        </Col>
                                    </Row>
                                </TabPane>

                                <TabPane tabId="hourly_rates">
                                    <Row>
                                        <Col sm="12 mt-4">
                                            <UserRoleRates
                                                user_role={data.user_role}
                                                data={data.user_role.hourly_rates}
                                            />
                                        </Col>
                                    </Row>
                                </TabPane>

                            </TabContent>
                            <ToastContainer/>
                        </div>
                    )
                }}

            </Query>
        )
    }

}

export default UserRole